import React from 'react';
import styled from 'styled-components';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';
import DatePicker from 'components/ui/DatePicker';
import moment from 'moment';

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

const CompletionDateTime = ({ setFieldValue, value, errors, touched, disabled }) => {
  return (
    <Col span={12}>
      <Form.Item label={`${getTranslatedString('landlordPortal.maintenance.completedOn')}`}>
        <StyledDatePicker
          name="completion_date"
          size="large"
          value={value}
          defaultPickerValue={moment().locale(getCurrentLocale())}
          showToday={true}
          placeholder="e.g. 2020-01-01 11:30 am"
          mobileMode="datetime"
          onChange={value => setFieldValue('completion_date', value)}
          showTime={{ format: 'h:mm a' }}
          format="YYYY-MM-DD hh:mm a"
          disabled={disabled}
        />
      </Form.Item>
    </Col>
  );
};

export default CompletionDateTime;
